import { BaseDistinctIdProvider } from './base_distinct_id_provider';

export class EmbedContextIdProvider extends BaseDistinctIdProvider {
    constructor(env, config = {}) {
        super(env, config);
        
        this.userInfo = {
            uid: config.user?.uid,
            ru: 0,
            iu: 0
        }
    }
    
    getIdInfo() {
        return Promise.resolve(this.userInfo)
    }
}